export default "__VITE_ASSET__ea80ce99__"